<dt ng-if="object.descricao.length > 25" uib-tooltip="{{object.descricao | capitalize}}" tooltip-append-to-body="true">
  {{object.descricao | capitalize | characters:25}}:
</dt>
<dt ng-if="object.descricao.length <= 25">
  {{object.descricao | capitalize}}:
</dt>
<dd>{{(object.summarize ? 'Sim' : 'Não')}}</dd>